'use client'
import { fieldLabelCls } from '@qr-front/ui/components/InputField'
import { cn } from '@qr-front/ui/utils'
import { ReactNode } from 'react'

import {
	TContactEntry,
	TContactType,
	TContactTypeOption,
} from './contactEntryTypes'
import { ContactTypeSelect } from './ContactTypeSelect'

type TContactEntryRowProps = {
	entry: TContactEntry
	options: TContactTypeOption[]
	fieldId: string
	groupLabel: string
	showGroupLabel: boolean
	onTypeChange: (type: TContactType) => void
	onLabelChange: (label: string) => void
	children: ReactNode
	action: ReactNode
}

export const ContactEntryRow = ({
	entry,
	options,
	fieldId,
	groupLabel,
	showGroupLabel,
	onTypeChange,
	onLabelChange,
	children,
	action,
}: TContactEntryRowProps) => (
	<div className="col-span-2">
		{showGroupLabel ? (
			<label htmlFor={fieldId} className={cn(fieldLabelCls, 'block')}>
				{groupLabel}
			</label>
		) : null}
		<div className="flex flex-col gap-2 tablet:flex-row tablet:items-start">
			<div className="w-full tablet:w-[200px]">
				<ContactTypeSelect
					ariaLabel={groupLabel}
					options={options}
					value={entry.type}
					label={entry.label}
					fieldId={fieldId}
					onChange={onTypeChange}
					onLabelChange={onLabelChange}
				/>
			</div>
			<div className="flex w-full items-start gap-2 tablet:flex-1">
				{children}
				{action}
			</div>
		</div>
	</div>
)
